import { Button, Group, Modal, TextInput, Textarea } from "@mantine/core"
import { useState } from "react";
import { useSelector } from "react-redux";
import { createButtonStyles } from "../../services/globalColor.js";
import { createCustomer } from "../../services/customer.js";

const CreateCustomer = ({ loading, set_loading, set_message, getCustomerMethod }) => {

    const userData = useSelector((state) => state.user.user);

    const [name, setName] = useState("");
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [address, setAddress] = useState('');
    const [notes, setNotes] = useState('');

    const [showCustomerCreateForm, setShowCustomerCreateForm] = useState(false);

    const sendCustomer = async (e) => {
        try {
            e.preventDefault();
            set_loading(true)
            set_message("Enviando información del cliente ...")
            if (userData && userData._id) {

                let data = {
                    name,
                    userId: userData._id,
                    email,
                    phone,
                    address,
                    notes
                };

                await createCustomer(data);
                await getCustomerMethod(true);

                setShowCustomerCreateForm(false);

                setName('');
                setEmail('');
                setPhone('');
                setAddress('');
                setNotes('');
                set_loading(false)
            }
        } catch (error) {
            set_loading(false)
        }
    };

    return <>
        <div style={{ textAlign: "right", marginBottom: "10px" }}>
            <Button
                onClick={() => setShowCustomerCreateForm(true)}
                
            >Añadir cliente</Button>
        </div>
        <Modal
            opened={showCustomerCreateForm}
            onClose={() => setShowCustomerCreateForm(false)}
            title="Añadir cliente"
            size="lg"
            closeOnClickOutside={false}
        >

            <form onSubmit={sendCustomer}>
                <TextInput
                    label="Nombre"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Introduce el nombre"
                    required
                    disabled={loading}
                    mb="md"
                />

                <TextInput
                    label="Email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Email del empleado"
                    disabled={loading}
                    mb="md"
                />

                <TextInput
                    label="Teléfono"
                    type="tel"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    placeholder="Número de teléfono"
                    disabled={loading}
                    mb="md"
                />

                <TextInput
                    label="Dirección"
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    placeholder="Dirección completa"
                    disabled={loading}
                    mb="md"
                />

                <Textarea
                    label="Notas"
                    value={notes}
                    onChange={(e) => setNotes(e.target.value)}
                    placeholder="Notas adicionales"
                    disabled={loading}
                    mb="md"
                />

                <Group position="apart" mt="xl">
                    <Button
                        type="button"
                        children="Cancelar"
                        variant="outline"
                        onClick={() => setShowCustomerCreateForm(false)}
                    />
                    <Button
                        type="submit"
                        children="Añadir cliente"
                        color="blue"
                        loading={loading}
                    />
                </Group>
            </form>
        </Modal>

    </>
}

export default CreateCustomer